import Panasonic from "../../img/firms/panasonic.png";
import PilsnerUrquell from "../../img/firms/pilsner_urquell.png";
import Tesco from "../../img/firms/tesco.jpg";
import Stock from "../../img/firms/stock.png";
import CD from "../../img/firms/cd-cele.png";
import SaintGobain from "../../img/firms/saint-gobain.png";
import PK from "../../img/firms/pk.jpg";
import ZOO from "../../img/firms/zoo.jpg";
import styled from "styled-components";
import Fade from 'react-reveal/Fade';

function Client(props){
    return(
        <Link href={props.link}>
            <Block className="client-block">
                <img src={props.img} alt={props.altImg}/>
            </Block>
        </Link>
    );
}
const Link = styled.a`
  
  .client-block:hover img{
    filter:grayscale(0);
  }
  @media only screen and (min-width: 1099px) and (max-width: 1400px){
    flex:0 0 30%;
  }
  @media only screen and (min-width: 600px) and (max-width: 1099px){
    flex: 0 0 46%;
  }
  @media only screen and (max-width: 599px){
    flex: 0 0 100%;
  }
`;
const Block = styled.div`
  background-color: white;
  display:flex;
  justify-content: center;
  align-items: center;
  
  width: 270px;
  height: 200px;
  border-radius: 20px 20px 0 20px;
  
  img{
    width: 160px;
    filter: grayscale(100%);
    transition:0.3s;
  }
  @media only screen and (max-width: 1400px){
   width: 100%;
  }
`;
function ListOfClients(){
    return(
        <div>
            <Title className="h-1 title-padding-1-bottom">
                <Fade top>
                    Naši klienti
                </Fade>
            </Title>
            <Clients >
                <Client img={Panasonic} imgAlt="Panasonic" link=""/>
                <Client img={PilsnerUrquell} imgAlt="Panasonic" link=""/>
                <Client img={Tesco} imgAlt="Panasonic" link=""/>
                <Client img={Stock} imgAlt="Panasonic" link=""/>
                <Client img={CD} imgAlt="Panasonic" link=""/>
                <Client img={SaintGobain} imgAlt="Panasonic" link=""/>
                <Client img={PK} imgAlt="Panasonic" link=""/>
                <Client img={ZOO} imgAlt="Panasonic" link=""/>
            </Clients>
        </div>
    );
}
const Title = styled.div`
  text-align: center;
`;
const Clients = styled.div`
  display:flex;
  flex-wrap: wrap;
  gap:40px;
  
`;
export default ListOfClients;